/**
 * Hover Zoom (lupa) para imagens de produto.
 * Ao passar o mouse sobre a imagem principal do produto (desktop, mouse fino),
 * mostra uma versão ampliada que acompanha o cursor, usando a imagem em
 * alta resolução já carregada pelo tema (atributo data-max-resolution).
 *
 * Não interfere no zoom por clique (zoom-dialog) já existente no tema.
 */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    return;
  }

  var ZOOM_SCALE = 2.2;
  var activeContainer = null;
  var activeOverlay = null;

  function getImage(container) {
    return container.querySelector('.product-media__image');
  }

  function getZoomSrc(img) {
    return img.getAttribute('data-max-resolution') || img.currentSrc || img.src;
  }

  function ensureOverlay(container, img) {
    var overlay = container.querySelector(':scope > .hover-zoom-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'hover-zoom-overlay';
      overlay.style.backgroundImage = 'url("' + getZoomSrc(img) + '")';
      overlay.style.backgroundSize = ZOOM_SCALE * 100 + '%';
      container.appendChild(overlay);
    }
    return overlay;
  }

  function updatePosition(overlay, container, event) {
    var rect = container.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    var x = ((event.clientX - rect.left) / rect.width) * 100;
    var y = ((event.clientY - rect.top) / rect.height) * 100;
    x = Math.max(0, Math.min(100, x));
    y = Math.max(0, Math.min(100, y));
    overlay.style.backgroundPosition = x + '% ' + y + '%';
  }

  document.addEventListener(
    'pointerover',
    function (event) {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      var container = event.target.closest('.product-media-container--zoomable');
      if (!container || container === activeContainer) return;
      // Skip the zoomed-in dialog view; only the inline gallery gets the hover lens.
      if (container.closest('.dialog-zoomed-gallery')) return;
      var img = getImage(container);
      if (!img) return;
      activeContainer = container;
      activeOverlay = ensureOverlay(container, img);
      activeOverlay.classList.add('is-visible');
    },
    true
  );

  document.addEventListener(
    'pointermove',
    function (event) {
      if (!activeContainer || !activeOverlay) return;
      if (!activeContainer.contains(event.target)) return;
      updatePosition(activeOverlay, activeContainer, event);
    },
    true
  );

  document.addEventListener(
    'pointerout',
    function (event) {
      if (!activeContainer) return;
      if (event.relatedTarget && activeContainer.contains(event.relatedTarget)) return;
      activeOverlay.classList.remove('is-visible');
      activeContainer = null;
      activeOverlay = null;
    },
    true
  );
})();
